import React, { useEffect } from 'react';
import { Card, Statistic } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getStationSummary } from '../../modules/analytics';
import './dashboard.css';

const SummaryCards = ({ stationId }) => {
  const dispatch = useDispatch();
  const inspectionTime = useSelector(state => state.analytics.inspectionTime);
  const summary = useSelector(
    state => (state.analytics.stationSummary || {})[stationId] || {}
  );

  useEffect(() => {
    if (stationId) {
      dispatch(getStationSummary(stationId));
    }
  }, [dispatch, stationId]);

  const price = inspectionTime.stationInfo?.estimatedSolarEnergyUnitPrice || 0;
  const round = n => Math.round(Number(n) || 0);
  const toCard = obj => ({
    value: round(obj?.value),
    unit: 'kWh',
    subtitle:
      '≈ ¥ ' + ((obj?.value || 0) * price).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    change: obj?.delta != null ? round(obj.delta) : 0,
  });

  const stats = {
    daily: toCard(summary.daily || {}),
    monthly: toCard(summary.monthly || {}),
    yearly: toCard(summary.yearly || {}),
    lifetime: {
      value: round(summary.lifetime),
      unit: 'kWh',
      subtitle:
        '≈ ¥ ' + ((summary.lifetime || 0) * price).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      change: '',
    },
  };

  const items = [
    { key: 'daily', title: 'Daily Generation', ...stats.daily },
    { key: 'monthly', title: 'Monthly Generation', ...stats.monthly },
    { key: 'yearly', title: 'Yearly Generation', ...stats.yearly },
    { key: 'lifetime', title: 'Lifetime Generation', ...stats.lifetime },
  ];
  return (
    <div className="summaryCards">
      {items.map(({ key, title, value, unit, subtitle, change }) => (
        <Card className="summaryCard" key={key}>
          <div className="summaryTitle">{title}</div>
          <div className="valuePanel">
            <Statistic value={value} suffix={unit} />
            <div className="statSubtitle">{subtitle}</div>
          </div>
          <div className="statChange">
            <b>{change !== 0 ? change.toLocaleString() : ''}</b>
            {key === 'daily'   && ' kWh from last 24h'}
            {key === 'monthly' && ' kWh from last 30 days'}
            {key === 'yearly'  && ' kWh from last 365 days'}
          </div>
        </Card>
      ))}
    </div>
  );
}



export default SummaryCards;
